import React from 'react';
import styles from './Performance.module.css';

interface AH07Component extends React.FC {
  title?: string;
}

const AH07: AH07Component = () => {
  return (
    <div>
      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Metric Description</div>
        <p>
          This is a percent calculated by dividing the of orders that have been in the Ready for Pickup (or Ready for Delivery) state for 7+ days and are closed out (picked up by or delivered to the customer), divided by the total # of orders that have been in the &quot;ready&quot; state for 7+ days. This metric excludes ship to home orders.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Supporting Details</div>
        <p>
          Find more information here:{' '}
          <a 
            href="https://acenet.aceservices.com/marketing/digital-marketing/acehardwarecom" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://acenet.aceservices.com/marketing/digital-marketing/acehardwarecom
          </a>
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Goal</div>
        <p>
          100% (All orders that had moved to the ready for pickup state should have been picked up by the customer after 7 days of moving to the ready for pickup step. Orders moving to ready for pickup trigger an email notification to the customer, telling them their order is ready for pickup).
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Update Cadence</div>
        <p>
          Metric is current state and updated monthly.
        </p>
      </div>

      <div className={styles.metricSection}>
        <div className={styles.sectionTitle}>Learn More</div>
        <p>
          Review this % to ensure your store is closing orders out as quickly as possible and within the recommended 7 day window.
        </p><br/>
        <p>
          For additional guidance review the Ace Way of Retailing acehardware.com fulfillment{' '}
          <a 
            href="https://acenet.aceservices.com/awor/acehardwarecom-order-management/customer-order-fulfillment" 
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Store Procedures
          </a>
        </p>
      </div>
    </div>
  );
};

// Attach title as a static property
AH07.title = 'Avg % of orders closed out after 7 days';

export default AH07;
